import { Heart, MapPin, Briefcase, GraduationCap, BadgeCheck, Bookmark, Video } from "lucide-react";
import { Link } from "react-router-dom";
import { avatarUrl } from "@/lib/api";
import { countryFlag } from "@/lib/constants";

export default function ProfileCard({ profile, onSendInterest, onShortlist, isShortlisted, compatibility }) {
  const photo = avatarUrl(profile, 640);
  return (
    <div className="card-elegant overflow-hidden group" data-testid={`profile-card-${profile.user_id}`}>
      <Link to={`/profile/${profile.user_id}`} className="block">
        <div className="aspect-[3/4] overflow-hidden bg-brand-muted relative">
          <img src={photo} alt={profile.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          {profile.is_verified && (
            <span className="absolute top-3 left-3 bg-white/95 text-brand-maroon text-[10px] tracking-[0.15em] uppercase font-semibold px-2 py-1 rounded-full flex items-center gap-1">
              <BadgeCheck className="h-3 w-3" /> Verified
            </span>
          )}
          {(compatibility?.score || profile.compatibility?.score) != null && (
            <span className="absolute top-3 right-3 bg-brand-maroon text-white text-xs font-semibold px-2 py-1 rounded-full">
              {compatibility?.score ?? profile.compatibility?.score}% match
            </span>
          )}
          {profile.video_url && (
            <span className="absolute bottom-3 left-3 bg-black/60 backdrop-blur-sm text-white text-[10px] tracking-[0.15em] uppercase font-semibold px-2 py-1 rounded-full flex items-center gap-1" data-testid={`video-badge-${profile.user_id}`}>
              <Video className="h-3 w-3" /> Video
            </span>
          )}
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-start justify-between gap-2">
          <div>
            <h3 className="font-serif text-xl text-brand-ink leading-tight">{profile.name}</h3>
            <p className="text-xs text-brand-inkLight mt-0.5">
              {profile.age ? `${profile.age} yrs` : "—"}
              {profile.height_cm ? ` · ${Math.floor(profile.height_cm / 30.48)}'${Math.round((profile.height_cm / 2.54) % 12)}"` : ""}
            </p>
          </div>
          <button onClick={() => onShortlist?.(profile.user_id)} className="p-2 rounded-full hover:bg-brand-muted" data-testid={`shortlist-btn-${profile.user_id}`}>
            <Bookmark className={`h-4 w-4 ${isShortlisted ? "fill-brand-gold text-brand-gold" : "text-brand-inkMute"}`} strokeWidth={1.5} />
          </button>
        </div>

        <ul className="mt-3 space-y-1.5 text-xs text-brand-inkLight">
          {(profile.location || profile.country) && <li className="flex items-center gap-1.5"><MapPin className="h-3 w-3" /> {profile.location}{profile.location && profile.country ? ", " : ""}{profile.country} {countryFlag(profile.country)}</li>}
          {profile.profession && <li className="flex items-center gap-1.5"><Briefcase className="h-3 w-3" /> {profile.profession}</li>}
          {profile.education && <li className="flex items-center gap-1.5"><GraduationCap className="h-3 w-3" /> {profile.education}</li>}
        </ul>

        <button
          onClick={() => onSendInterest?.(profile.user_id)}
          className="mt-4 w-full bg-brand-maroon text-white py-2.5 rounded-md text-sm font-medium hover:bg-brand-maroonDark transition-colors flex items-center justify-center gap-2"
          data-testid={`send-interest-btn-${profile.user_id}`}
        >
          <Heart className="h-3.5 w-3.5" strokeWidth={1.5} /> Send Interest
        </button>
      </div>
    </div>
  );
}
